import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { MdDownload, MdOutlineVisibility } from "react-icons/md";

import { ReactComponent as GeneralReportsIcon } from "../../../assets/Group326.svg";
import Button from "../../../components/Button";
import schoolServices from "../../../services/schoolServices";

const GeneralReports = () => {
  const { t } = useTranslation();
  const [generatingReport, setGeneratingReport] = useState(false);
  const [previewReport, setPreviewReport] = useState(false);

  const handleGenerateGeneralReport = async () => {
    setGeneratingReport(true);
    try {
      let fileName = `${"general"}-report.pdf`;

      const response = await schoolServices.generateGeneralReport();

      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName;

      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error generating student report:", error);
    } finally {
      setGeneratingReport(false);
    }
  };

  const handlePreviewGeneralReport = async () => {
    setPreviewReport(true);
    try {
      const response = await schoolServices.generateGeneralReport();

      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      window.open(url, "_blank");
      // Optional: revokeObjectURL after some time to free up memory
      setTimeout(() => window.URL.revokeObjectURL(url), 5000);
    } catch (error) {
      console.error("Error previewing general report:", error);
    } finally {
      setPreviewReport(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center p-6 xl:flex-row xl:space-x-6">
      {/* General School Report Card */}
      <div className="w-full max-w-lg rounded-lg bg-white p-8 shadow-md dark:bg-dark-surface">
        {/* Header */}
        <div className="mb-6 flex items-center space-x-4">
          <GeneralReportsIcon className="h-12 w-12 text-blue-500" />
          <h3 className="text-2xl font-semibold text-blue-500 md:text-2xl">{t("general_school_report")}</h3>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col space-y-4">
          <Button
            className="w-full"
            color="green"
            size="lg"
            loading={previewReport}
            iconLeft={<MdOutlineVisibility size={22} />}
            onClick={handlePreviewGeneralReport}
            label={t("preview")}
          />
          <Button
            className="w-full"
            color="blue"
            iconLeft={<MdDownload size={22} />}
            size="lg"
            loading={generatingReport}
            onClick={handleGenerateGeneralReport}
            label={t("download")}
          />
        </div>
      </div>
    </div>
  );
};

export default GeneralReports;
